import {Card, CardContent} from '@/components/ui/card'
import {Users2Icon} from 'lucide-react'
import {useCalculator, KPI_NASTUPY} from '@/contexts/CalculatorContext'

export function NastupyBonusCard() {
    const {
        isKpiMet,
        nastupy,
        contracts,
        getNastupyPercentage,
        getNastupyColor,
        getCardAnimation
    } = useCalculator()

    return (
        <Card
            className={`transition-all duration-300 border-2 ${getNastupyColor(nastupy)} ${getCardAnimation(2)} relative`}>
            <CardContent className="pt-6">
                <div className="space-y-3">
                    <div className="flex items-center gap-2">
                        <Users2Icon className={`w-4 h-4 ${
                            nastupy >= KPI_NASTUPY ? 'text-green-500' :
                                nastupy >= 3 ? 'text-orange-500' :
                                    'text-red-500'
                        }`}/>
                        <span className="font-medium">2. složka <span className="text-xs">(za 6 měsíců)</span></span>
                        {nastupy >= KPI_NASTUPY ? (
                            <span className="text-xs text-green-500 font-medium">
                                Dílčí KPI Splněno! ✓
                            </span>
                        ) : (
                            <span className="text-xs text-orange-500 text-muted-foreground">
                                {nastupy < KPI_NASTUPY ? `Chybí ${KPI_NASTUPY - nastupy} nástupů` :
                                    contracts < 1 ? `Chybí 1 smlouva` :
                                        'Dílčí KPI nesplněno'}
                            </span>
                        )}
                    </div>
                    <div className="space-y-2">
                        <div className="flex justify-between items-center w-full">
                              <span className="text-xs text-muted-foreground">
                              Extra bonus pro příští období 6 mesíců
                                </span>
                                            <span className="text-2xl font-bold ">
                                {isKpiMet ? getNastupyPercentage(nastupy) : 0}%
                              </span>
                        </div>
                    </div>
                    <div className="w-full pt-2 border-t">
                        <div className="text-xs text-muted-foreground">
                            {nastupy < KPI_NASTUPY ?
                                `Potřebujete ještě ${KPI_NASTUPY - nastupy} nástupů` :
                                `Dílčí KPI splněno (${nastupy} nástupů)`}
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
} 